export default "__VITE_ASSET__0aa505f3__"